import legacyMessages from "../legacy";
import currentEn from "../en";
import currentHk from "../hk";
import currentZh from "../zh";

const localeSources = {
  en: { ...legacyMessages.en, ...currentEn },
  cn: { ...legacyMessages.zh_cn, ...currentZh },
  hk: { ...legacyMessages.zh_hk, ...currentHk },
};

const keyAliases = {
  "Payment me": "Payment method",
  Seate: "Seated",
  addres: "address",
  Cancelle: "Cancelled",
};

// ? 將舊翻譯 key 統一轉為可使用點號查找的格式
const normalizeMessageKey = (key) => {
  // * 空格與點號路徑不支援的符號統一轉為底線
  return String(key)
    .trim()
    .replace(/[^A-Za-z0-9_\u00C0-\uFFFF]+/g, "_")
    .replace(/_+/g, "_");
};

const valueOverrides = {
  en: {
    "No address": "No address",
    "Cancel queue": "Cancel queue",
    "Account detection": "Account detection",
    "Identity verification": "Identity verification",
    "Account cancellation agreement": "Account cancellation agreement",
    "Collect coupon immediately": "Collect coupon now",
    "Activity ended": "Activity ended",
    "Check code": "Check code",
    "Please contact the staff for the check code":
      "Please contact the staff for the check code",
    "Incorrect check code, please enter again":
      "Incorrect check code, please enter again",
    "Popular restaurants": "Popular restaurants",
    "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh":
      "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh",
    regulatio: "Regulation",
    "WhatsApp prompts the latest trends of queuing":
      "WhatsApp prompts the latest trends of queuing",
    "請勿重複下單!": "Please do not submit duplicate orders!",
  },
  cn: {
    "No address": "暂无地址",
    "Cancel queue": "取消排队",
    "Account detection": "账户检测",
    "Identity verification": "身份验证",
    "Account cancellation agreement": "注销协议",
    "Collect coupon immediately": "立即领券",
    "Activity ended": "活动已结束",
    "Check code": "校验码",
    "Please contact the staff for the check code": "请联系服务员获取校验码",
    "Incorrect check code, please enter again": "校验码错误，请重新输入",
    "Popular restaurants": "热门餐厅",
    regulatio: "规定",
    "請勿重複下單!": "请勿重复下单!",
  },
  hk: {
    "No address": "暫無地址",
    "Cancel queue": "取消排隊",
    "Account detection": "賬戶檢測",
    "Identity verification": "身份驗證",
    "Account cancellation agreement": "註銷協議",
    "Collect coupon immediately": "立即領券",
    "Activity ended": "活動已結束",
    "Check code": "校驗碼",
    "Please contact the staff for the check code": "請聯繫服務員獲取校驗碼",
    "Incorrect check code, please enter again": "校驗碼錯誤，請重新輸入",
    "Popular restaurants": "熱門餐廳",
    regulatio: "規定",
    "請勿重複下單!": "請勿重複下單!",
  },
};

// ? 將指定翻譯 key 整理為 vue-i18n 功能命名空間
export const createLegacyModule = (keys) => {
  // * 優先沿用目前翻譯檔內容，缺少時再兼容舊翻譯資料
  return Object.keys(localeSources).reduce((messages, locale) => {
    const source = localeSources[locale];
    messages[locale] = keys.reduce((result, key) => {
      const sourceKey = keyAliases[key] || key;
      result[normalizeMessageKey(key)] =
        valueOverrides[locale][key] !== undefined
          ? valueOverrides[locale][key]
          : source[sourceKey] !== undefined
            ? source[sourceKey]
            : key;
      return result;
    }, {});
    return messages;
  }, {});
};
